import axios from "axios";
import { BASE_URL } from "../shared/constants";

const PORTAL = `${BASE_URL}/portal/api`;

// The staff half of the board's `client` prop.
//
// Deliberately NOT an axios.create() instance. The staff bearer token and the
// 401->refresh interceptor are both set on the global axios inside App.js's
// mount effect, and an instance created at module load would copy neither —
// it would hold an empty Authorization and answer a 401 by giving up rather
// than refreshing. So this is a thin path adapter over the global axios, and
// every staff call still goes out exactly as it did before.
//
// The manager portal passes its own `bm` instance (portal_bm/bmClient.js),
// which carries its own token and its own refresh interceptor. All the board
// asks of either is these four methods and a base path it does not have to
// know about.
export const portalClient = {
  get: (path, config) => axios.get(`${PORTAL}${path}`, config),
  post: (path, data, config) => axios.post(`${PORTAL}${path}`, data, config),
  patch: (path, data, config) => axios.patch(`${PORTAL}${path}`, data, config),
  delete: (path, config) => axios.delete(`${PORTAL}${path}`, config),
};
